import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Message } from "@components";
import ApplePayDomainDrawer from "./ApplePayDrawer/ApplePayDomainDrawer";
import ApplePayCertificateDrawer from "./ApplePayDrawer/ApplePayCertificateDrawer";
import { IntegrationsAPI } from "providers/IntegrationsAPI";

export default class ApplePayDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const currentConfigs = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "apple_pay"
    );
    const configs = currentConfigs || {};

    if (Object.keys(configs).length > 0) {
      this.setState({
        merchantId: configs?.merchantId,
        merchantName: configs?.merchantName,
        email: configs?.email,
      });
    }

    this.setState({
      loadingPage: false,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { merchantId, merchantName, email } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const merchant = {
        merchantId,
        merchantName,
        email,
      };
      const merchantResponse = await IntegrationsAPI.upsertApplePayMerchant(
        environmentId,
        merchant
      );

      this.setState({ loading: false });

      if (merchantResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível atualizar - ${
            merchantResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, loadingPage, merchantId, merchantName, email } = this.state;
    const { visible, onClose } = this.props;

    const isValid = merchantId && merchantName && email;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Apple Pay"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Message className="mb-20" type="warning">
              <p>
                Integração disponível apenas através da <b>Pagar.me</b>.
              </p>
            </Message>

            <Input
              design="two"
              className="mb-20"
              floatLabel="MerchantId"
              value={merchantId}
              onChange={(e) => this.setState({ merchantId: e.target.value })}
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="MerchantName"
              value={merchantName}
              onChange={(e) => this.setState({ merchantName: e.target.value })}
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="E-mail"
              value={email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />

            <Button
              design="primary"
              className="w-100 mb-20"
              onClick={() => this.setState({ openDomain: true })}
            >
              Configurar domínios
            </Button>

            <Button
              design="primary"
              className="w-100 mb-20"
              onClick={() => this.setState({ openCertificate: true })}
            >
              Configurar certificado
            </Button>
          </div>
        )}

        {this.state.openDomain && (
          <ApplePayDomainDrawer
            onClose={() => this.setState({ openDomain: false })}
          />
        )}
        {this.state.openCertificate && (
          <ApplePayCertificateDrawer
            onClose={() => this.setState({ openCertificate: false })}
          />
        )}
      </Drawer>
    );
  }
}
